<template>
  <div class="checkbox-wrapper">
    <div
      :id="getId"
      class="input g-visually-hidden"
      :class="{ checked, disabled }"
    ></div>
    <label class="label" :for="getId">
      <span class="checkbox" :class="{ disabled }"></span>
    </label>
  </div>
</template>

<script>
import { getUniqueId } from "@/assets/js/utils/get-unique-id";
export default {
  props: {
    checked: {
      type: Boolean,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
  },
  computed: {
    getId() {
      return getUniqueId("checkbox");
    },
  },
};
</script>

<style lang="scss" scoped>
.checkbox {
  position: relative;
  background-color: var.$white;
  border: 1px solid var.$gray-dark;
  border-radius: 4px;
  box-sizing: border-box;
  flex-shrink: 0;
  display: inline-block;
  height: 20px;
  width: 20px;
  transition: border-color 0.3s, background-color 0.3s;

  &-wrapper {
    display: flex;
    align-items: center;
    position: relative;
  }

  &::before,
  &::after {
    content: "";
    position: absolute;
    background-color: transparent;
    transition: background-color 0.3s;
  }

  &::before {
    top: calc(50% + 2px);
    left: calc(50% - 5px);
    transform: translate(-50%, -50%) rotate(-45deg);
    height: 6px;
    width: 2px;
  }

  &::after {
    top: 50%;
    left: calc(50% + 2px);
    transform: translate(-50%, -50%) rotate(45deg);
    height: 14px;
    width: 2px;
  }

  &.disabled {
    background: #eeeef2;
    cursor: default;
  }
}

.input.checked + .label .checkbox {
  border-color: var.$green-main;
  background-color: var.$green-main;

  &::before,
  &::after {
    background-color: var.$white;
  }
}
</style>
